import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="10"
    height="11"
    viewBox="0 0 10 11"
    stroke="currentColor"
    fill="transparent"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M3.83174 8H6.16821M4.99997 1V1.5M8.18195 2.31802L7.8284 2.67157M9.5 5.49997H9M1 5.49997H0.5M2.17155 2.67157L1.81799 2.31802M3.23221 7.26778C2.2559 6.29147 2.2559 4.70856 3.23221 3.73224C4.20852 2.75593 5.79143 2.75593 6.76774 3.73224C7.74405 4.70856 7.74405 6.29147 6.76774 7.26778L6.49419 7.54133C6.17775 7.85777 5.99997 8.28696 5.99997 8.73448V9C5.99997 9.55228 5.55226 10 4.99997 10C4.44769 10 3.99997 9.55228 3.99997 9V8.73448C3.99997 8.28696 3.8222 7.85777 3.50576 7.54133L3.23221 7.26778Z" />
  </svg>
);
